import config from '@epi-config';
import { get, post } from '@epi-helpers/FetchHelpers';
import { IBenefits } from '@epi-models/containers/ManageBenefits';
import { TopupsSummary } from '@epi-models/pages/Reports';
import {
  TopupEmployeesResponse,
  TopupInProgressResponse
} from '@epi-models/pages/Transfer';

export const topupLoadApiUrl = `${config.apiHost}/api/top-up-load`;

export const topupBenefitPending = `${topupLoadApiUrl}/pending/for-benefit`;

export const topupEmployeesApiUrl = (benefitType, scheduleDate) =>
  `${topupLoadApiUrl}/employees-top-ups/${benefitType}${
    scheduleDate ? '?scheduledOn=' + scheduleDate : ''
  }`;

export const getTopupInProgressRequest = (
  abortController: AbortController | null = null
): Promise<TopupInProgressResponse> => {
  return get(
    `${topupLoadApiUrl}/in-progress`,
    undefined,
    undefined,
    abortController?.signal
  );
};

export const getTopupEmployeesRequest = (
  scheduleDate: string | null,
  benefitType?: IBenefits,
  abortController: AbortController | null = null
): Promise<TopupEmployeesResponse> => {
  return get(
    topupEmployeesApiUrl(benefitType, scheduleDate),
    undefined,
    undefined,
    abortController?.signal
  );
};

export const postTopupEmployeesRequest = (
  scheduleDate: string | null,
  benefitType?: IBenefits,
  groupIds?: number[]
): Promise<TopupEmployeesResponse> => {
  const data = {
    ScheduledOn: scheduleDate,
    GroupIds: groupIds
  };
  return post(`${topupLoadApiUrl}/employees-top-ups/${benefitType}`, data);
};

export const getTopupReportsRequest = (
  abortController: AbortController | null = null
): Promise<TopupsSummary> => {
  return get(
    `${topupLoadApiUrl}/summary`,
    undefined,
    undefined,
    abortController?.signal
  );
};

export const getTopupReportDetailsRequest = (
  topupId: string,
  abortController: AbortController | null = null
) => {
  return get(
    `${topupLoadApiUrl}/${topupId}`,
    undefined,
    undefined,
    abortController?.signal
  );
};
